var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');

var DocumentMetaForm = require('./document-meta-form');

var DocumentMetaModal = Marionette.View.extend({
    template: require('../../templates/documents/document-meta-modal.html'),

    regions: {
        documentMetaForm: '#document-meta-form'
    },

    ui: {
        modal: '#addMetaModal',
        saveMeta: '#save',
    },

    events: {
        'click @ui.saveMeta': 'saveMeta',
    },

    childViewEvents: {
        'meta:saved': 'onMetaSaved',
    },

    templateContext: function () {
        var that = this;
        return {
            metadataId: that.metadataId
        }
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();

        that.meta = options.meta;
        that.metadataId = options.metadataId;
        that.documentId = options.documentId;
        that.successCallback = options.successCallback;
    },

    onRender: function () {
        var that = this;
        that.show();

        that.showChildView('documentMetaForm', new DocumentMetaForm({
            documentId: that.documentId,
            meta: that.meta,
            metadataId: that.metadataId,
            successCallback: that.successCallback
        }));
    },

    saveMeta: function () {
      this.getChildView('documentMetaForm').saveMeta();
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    onMetaSaved: function () {
        this.hide();
    }
});

module.exports = DocumentMetaModal;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-meta-modal.js
// module id = 394
// module chunks = 0